
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const timeentryApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listTimeEntries: builder.query ({
      query: (params) => `v2/timeentry/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["TimeEntry"]
    }),
    getTimeEntry: builder.query ({
      query: (timeentry_id) => `v2/timeentry/${timeentry_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["TimeEntry"]
    }),

    updateTimeEntry: builder.mutation ({
      query: ({timeentry_id, data}) => ({
        url: `v2/timeentry/${timeentry_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["TimeEntry"]
    }),
    deleteTimeEntry: builder.mutation ({
      query: (timeentry_id) => ({
        url: `v2/timeentry/${timeentry_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["TimeEntry"]
    }),
    createTimeEntry: builder.mutation ({
      query: (data) => ({
        url: `v2/timeentry/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["TimeEntry"]
    }),
  })
})


export const {
  useListTimeEntriesQuery,
  useLazyListTimeEntriesQuery,
  useGetTimeEntryQuery,
  useLazyGetTimeEntryQuery,

  useUpdateTimeEntryMutation,
  useDeleteTimeEntryMutation,
  useCreateTimeEntryMutation
} = timeentryApi
